import Component from '../core/Component'
import Flickity from 'flickity'
import { CMS } from '../core/config'

export default class Slider extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            slider: null
        }
    }

    prepare() {
        if (CMS) {
            return
        }
        const flickty = new Flickity(this.ref.slider,{
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            groupCells: '100%',
            ...this.options.flickityOptions
        })
    }
}